
export default {
  name: 'SendMessage',
  data: () => ({
    titulo: '',
    mensaje: '',
    navigation: [{ text: 'Home', boxIcon: 'home', navigate: 'home' }, { text: 'Enviar mensaje' }],
  }),
};
